/**
 * Normalizes any common Indian mobile format to +91XXXXXXXXXX.
 * If the number cannot be cleaned to exactly 10 digits, returns the original string.
 */
export function mobileClean(raw) {
  if (!raw) return raw;
  let s = String(raw).trim();

  // Strip spaces, dashes, dots, brackets, parentheses
  s = s.replace(/[\s\-.()[\]]/g, '');

  // Remove leading +
  if (s.startsWith('+')) s = s.slice(1);

  // Strip country code
  if (s.startsWith('91') && s.length === 12) {
    s = s.slice(2);
  } else if (s.startsWith('0') && s.length === 11) {
    s = s.slice(1);
  }

  // Must be exactly 10 digits now
  if (/^\d{10}$/.test(s)) {
    return `+91${s}`;
  }

  return String(raw).trim(); // return original if unrecognised format
}
